import CustomButton from "@components/buttons/CustomButton";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { transactionApiServices } from "@services/apis/Transactions";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface ConfirmClearComplianceModalProps {
  open: boolean;
  transactionId?: number;
  onClose: () => void;
  onSuccess?: (transactionId: number) => void;
}

const ConfirmClearComplianceModal = ({
  open,
  transactionId,
  onClose,
  onSuccess,
}: ConfirmClearComplianceModalProps) => {
  const { handleError, handleSuccess } = useSnackbarMessage();
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const handleClear = async () => {
    if (transactionId == null) return;
    setLoading(true);
    try {
      const response = await transactionApiServices.clearCompliance(
        transactionId,
      );
      handleSuccess({
        message: response?.msg || "Compliance cleared successfully",
      });
      onSuccess?.(transactionId);
      onClose();
    } catch (error: any) {
      handleError({
        message:
          error?.response?.data?.msg ||
          error?.message ||
          "Failed to clear compliance",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={open && transactionId != null}
      onClose={loading ? () => {} : onClose}
      onClickCross={loading ? () => {} : onClose}
      heading="Clear Compliance"
      showConfirm={false}
      showCross={!loading}
      isMobile={isMobile}
    >
      <div className="p-4 flex flex-col gap-4">
        <p className="text-xs text-text-subtle">
          You are about to clear compliance for transaction{" "}
          <strong className="text-text-base">{transactionId}</strong>. This
          marks the transaction as compliance cleared. Do you want to continue?
        </p>
        <div className="flex flex-col gap-2">
          <CustomButton
            text="CLEAR"
            isActive={true}
            isButtonLoading={loading}
            onClick={handleClear}
          />
          <CustomButton
            text="CANCEL"
            isActive={!loading}
            isHollow
            onClick={onClose}
          />
        </div>
      </div>
    </SlidingPanel>
  );
};

export default ConfirmClearComplianceModal;
